import OEColor from '../../components/color-picker/oe-color';
import OEColorHelper from '../color/oe-color-helper';
import {OEVersion} from '../../react-oe/oe-version';
import {OETarget} from '../../react-oe/oe-target';

export class OEStyleSheetTool {
    
    constructor(document_ = document, updateStyleMobileTimerDev = false) {
        this.document = document_;

        this.rules = {};
        this.additionalStyles = [];

        this.brightness = 0.6;
        this.borderBrightness = 0.6;

        this.onUpdateStyleMobileTimer = this.onUpdateStyleMobileTimer.bind(this);

        if(updateStyleMobileTimerDev && process.env.NODE_ENV === 'development')  {
            setTimeout(this.onUpdateStyleMobileTimer, 1000);
        }
    }

    onUpdateStyleMobileTimer()  {
        this.updateStyleMobile();
        setTimeout(this.onUpdateStyleMobileTimer, 1000);
    }

    printStyleSheets()  {
        for(let i = 0; i < this.document.styleSheets.length; i++) {
            let sheet = this.document.styleSheets[i];
            console.log(sheet.title);
        }
    }

    printStyleSheetRules(title, range)  {
        let sheet = this.getStyleSheet(title);
        if(!sheet) return;

        let rules = sheet.cssRules;

        let first = !range || !range.first ? 0 : range.first;
        let last = !range || !range.last ? rules.length - 1 : Math.min(range.last, rules.length - 1);

        for(let i = first; i < last; ++i)   {
            console.log(rules[i].cssText);
        }
    }

    getStyleSheet(title) {
        let title_ = title || 'styles';

        for(let i = 0; i < this.document.styleSheets.length; i++) {
            let sheet = this.document.styleSheets[i];
            if(sheet.title === title_) {
                return sheet;
            }
        }
    }

    getRule(index, title)   {
        let sheet = this.getStyleSheet(title);
        if(!sheet || sheet.cssRules.length <= index || index < 0) return;
        return sheet.cssRules[index];
    }

    insertRule(name, rule, index, title) {
        if(this.rules[name]) {
            this.rules[name].refCount++;
            return;
        }

        let sheet = this.getStyleSheet(title);
        if(!sheet) return;

        const index_ = typeof(index) === 'number' ? index : sheet.cssRules.length;
        if(index_ > sheet.cssRules.length || index_ < 0) return;
        
        const ruleIndex = sheet.insertRule(rule, index_);
        if(typeof(ruleIndex) !== 'number')   return;

        //
        let keys = Object.keys(this.rules);
        for(let i = 0; i < keys.length; ++i)  {
            let key = keys[i];
            let rule_ = this.rules[key];
            if(rule_.index >= ruleIndex)   {
                rule_.index++;
            }
        }

        this.rules[name] = {index: ruleIndex, refCount: 1};
        return ruleIndex;
    }

    removeRule(name, title, respectRefCount) {
        if(!this.rules[name])   return;
        let rule = this.rules[name];
        if(respectRefCount && rule.refCount > 1)    {
            rule.refCount--; return;
        }
        let sheet = this.getStyleSheet(title);

        if(sheet && rule.index < sheet.cssRules.length && rule.index >= 0 ) {
            sheet.deleteRule(rule.index);
        }

        //
        delete this.rules[name];

        let keys = Object.keys(this.rules);
        for(let i = 0; i < keys.length; ++i)  {
            let key = keys[i];
            if(this.rules[key].index > rule.index)   {
                this.rules[key].index--;
            }
        }
    }

    setFullscreenRule(enable)   {
        if(enable)  {
            //this.insertRule('fullscreen1', ':not(.fullscreen-element) { visibility: hidden !important; -webkit-transform: none !important; transform: none !important;}', 0);
            this.insertRule('fullscreen1', ':not(.fullscreen-element) { visibility: hidden !important; }', 0);
            this.insertRule('fullscreen2', '.modal-dialog { -webkit-transform: none !important; transform: none !important; }', 0);
            this.insertRule('fullscreen3', 'body { background-color: #000000 !important; }', 0);
        } else {
            this.removeRule('fullscreen1');
            this.removeRule('fullscreen2');
            this.removeRule('fullscreen3');
        }

        //this.printStyleSheetRules(null, {last: 3});
    }

    removeBgColorRule(selector) {
        return this.removeRule('bg-' + selector);
    }

    removeColorRule(selector) {
        return this.removeRule('color-' + selector);
    }

    removeBorderColorRule(selector) {
        return this.removeRule('border-color' + selector);
    }

    removeBorderRule(selector) {
        return this.removeRule('border-' + selector);
    }

    encloseRuleWithHoverMedia(rule) {
        return '@media (any-hover: hover) and (any-pointer: fine) {' + rule + '}'
    }

    addBgColorRule(selector, color, hover) {
        let rule = selector + ' { background-color: ' + OEColor.toDOMStr(color) + ' !important; }';
        if(hover)   rule = this.encloseRuleWithHoverMedia(rule);
        return this.insertRule('bg-' + selector, rule);
    }

    addColorRule(selector, color, hover) {
        let rule = selector + ' { color: ' + OEColor.toDOMStr(color) + ' !important; }';
        if(hover)   rule = this.encloseRuleWithHoverMedia(rule);
        return this.insertRule('color-' + selector, rule);
    }

    addBorderColorRule(selector, color, hover) {
        let rule = selector + ' { border-color: ' + OEColor.toDOMStr(color) + ' !important; }';
        if(hover)   rule = this.encloseRuleWithHoverMedia(rule);
        return this.insertRule('border-color' + selector, rule);
    }

    addBorderRule(selector, color, hover) {
        let rule = selector + ' { border: 1px solid ' + OEColor.toDOMStr(color) + ' !important; }';
        if(hover)   rule = this.encloseRuleWithHoverMedia(rule);
        return this.insertRule('border-' + selector, rule);
    }

    removeColorStyle() {
        const multi = [{pf: ''}, {pf: '-border'}];

        for(let i = 0; i < multi.length; ++i)   {
            const m = multi[i];

            this.removeBgColorRule('.extra-light-bg' + m.pf);
            this.removeBgColorRule('.extra-light-bg' + m.pf + '.active');
            this.removeBgColorRule('.extra-light-hover-bg' + m.pf);
            this.removeBgColorRule('.extra-light-hover-bg' + m.pf + '.active');
            this.removeBgColorRule('.extra-light-hover-bg' + m.pf + ':hover');
            this.removeBgColorRule('.extra-light-hover-bg' + m.pf + '.active:hover');
            this.removeBgColorRule('.extra-light-bg' + m.pf + '.disabled:hover');
            this.removeBgColorRule('.extra-light-hover-bg' + m.pf + '.disabled:hover');
            this.removeBgColorRule('.extra-light-hover-bg-hover' + m.pf + ':hover');

            this.removeBgColorRule('.light-bg' + m.pf);
            this.removeBgColorRule('.light-bg' + m.pf + '.active');
            this.removeBgColorRule('.light-hover-bg' + m.pf);
            this.removeBgColorRule('.light-hover-bg' + m.pf + '.active');
            this.removeBgColorRule('.light-hover-bg' + m.pf + ':hover');
            this.removeBgColorRule('.light-hover-bg' + m.pf + '.active:hover');
            this.removeBgColorRule('.light-bg' + m.pf + '.disabled:hover');
            this.removeBgColorRule('.light-hover-bg' + m.pf + '.disabled:hover');
            this.removeBgColorRule('.light-hover-bg-hover' + m.pf + ':hover');

            this.removeBgColorRule('.std-bg' + m.pf);
            this.removeBgColorRule('.std-bg' + m.pf + '.active');
            this.removeBgColorRule('.std-hover-bg' + m.pf);
            this.removeBgColorRule('.std-hover-bg' + m.pf + '.active');
            this.removeBgColorRule('.std-hover-bg' + m.pf + ':hover');
            this.removeBgColorRule('.std-hover-bg' + m.pf + '.active:hover');
            this.removeBgColorRule('.std-bg' + m.pf + '.disabled:hover');
            this.removeBgColorRule('.std-hover-bg' + m.pf + '.disabled:hover');
            this.removeBgColorRule('.std-hover-bg-hover' + m.pf + ':hover');

            this.removeBgColorRule('.main-menu-bg' + m.pf);
            this.removeBgColorRule('.std-toolbar-bg' + m.pf);
            this.removeBgColorRule('.view-bg' + m.pf);
            this.removeBgColorRule('.start-view-bg' + m.pf);

            this.removeBgColorRule('.std-label-text-color-bg' + m.pf);
            this.removeBgColorRule('.view-port-label-text-color-bg' + m.pf);

            this.removeColorRule('.std-label-text-color' + m.pf);
            this.removeColorRule('.view-port-label-text-color' + m.pf);
            this.removeColorRule('.main-menu-text-color' + m.pf);

            this.removeBgColorRule('.std-separator-color' + m.pf);
            this.removeBgColorRule('.std-overlay-view-bg' + m.pf);

            this.removeBorderColorRule('.std-label-border-color' + m.pf);
            this.removeBorderColorRule('.std-border-color' + m.pf);
            this.removeBorderColorRule('.std-separator-border-color' + m.pf);
            this.removeBorderColorRule('.dark-border-color' + m.pf);
            this.removeBorderColorRule('.dark-separator-border-color' + m.pf);

            this.removeBorderRule('.std-border' + m.pf);
            this.removeBorderRule('.dark-border' + m.pf);
            this.removeBorderRule('.view-port-border' + m.pf);
            this.removeBorderRule('.media-center-slide-preview-magni-border' + m.pf);
        }
    }

    addColorStyle(brightness, borderBrightness) {
        const multi = [{pf: '', brightness: brightness}, {pf: '-border', brightness: borderBrightness}];

        for(let i = 0; i < multi.length; ++i)   {
            const m = multi[i];

            this.addBgColorRule('.extra-light-bg' + m.pf, OEColorHelper.extraLightBackgroundColor(m.brightness));
            this.addBgColorRule('.extra-light-bg' + m.pf + '.active', OEColorHelper.extraLightActiveBackgroundColor(m.brightness));
            this.addBgColorRule('.extra-light-hover-bg' + m.pf, OEColorHelper.extraLightBackgroundColor(m.brightness));
            this.addBgColorRule('.extra-light-hover-bg' + m.pf + '.active', OEColorHelper.extraLightActiveBackgroundColor(m.brightness));
            this.addBgColorRule('.extra-light-hover-bg' + m.pf + ':hover', OEColorHelper.extraLightHoverBackgroundColor(m.brightness), true);
            this.addBgColorRule('.extra-light-hover-bg' + m.pf + '.active:hover', OEColorHelper.extraLightActiveHoverBackgroundColor(m.brightness), true);
            this.addBgColorRule('.extra-light-bg' + m.pf + '.disabled:hover', OEColorHelper.extraLightBackgroundColor(m.brightness), true);
            this.addBgColorRule('.extra-light-hover-bg' + m.pf + '.disabled:hover', OEColorHelper.extraLightBackgroundColor(m.brightness), true);
            this.addBgColorRule('.extra-light-hover-bg-hover' + m.pf + ':hover', OEColorHelper.extraLightHoverBackgroundColor(m.brightness), true);

            this.addBgColorRule('.light-bg' + m.pf, OEColorHelper.lightBackgroundColor(m.brightness));
            this.addBgColorRule('.light-bg' + m.pf + '.active', OEColorHelper.lightActiveBackgroundColor(m.brightness));
            this.addBgColorRule('.light-hover-bg' + m.pf, OEColorHelper.lightBackgroundColor(m.brightness));
            this.addBgColorRule('.light-hover-bg' + m.pf + '.active', OEColorHelper.lightActiveBackgroundColor(m.brightness));
            this.addBgColorRule('.light-hover-bg' + m.pf + ':hover', OEColorHelper.lightHoverBackgroundColor(m.brightness), true);
            this.addBgColorRule('.light-hover-bg' + m.pf + '.active:hover', OEColorHelper.lightActiveHoverBackgroundColor(m.brightness), true);
            this.addBgColorRule('.light-bg' + m.pf + '.disabled:hover', OEColorHelper.lightBackgroundColor(m.brightness), true);
            this.addBgColorRule('.light-hover-bg' + m.pf + '.disabled:hover', OEColorHelper.lightBackgroundColor(m.brightness), true);
            this.addBgColorRule('.light-hover-bg-hover' + m.pf + ':hover', OEColorHelper.lightHoverBackgroundColor(m.brightness), true);

            this.addBgColorRule('.std-bg' + m.pf, OEColorHelper.stdBackgroundColor(m.brightness));
            this.addBgColorRule('.std-bg' + m.pf + '.active', OEColorHelper.stdActiveBackgroundColor(m.brightness));
            this.addBgColorRule('.std-hover-bg' + m.pf, OEColorHelper.stdBackgroundColor(m.brightness));
            this.addBgColorRule('.std-hover-bg' + m.pf + '.active', OEColorHelper.stdActiveBackgroundColor(m.brightness));
            this.addBgColorRule('.std-hover-bg' + m.pf + ':hover', OEColorHelper.stdHoverBackgroundColor(m.brightness), true);
            this.addBgColorRule('.std-hover-bg' + m.pf + '.active:hover', OEColorHelper.stdActiveHoverBackgroundColor(m.brightness), true);
            this.addBgColorRule('.std-bg' + m.pf + '.disabled:hover', OEColorHelper.stdBackgroundColor(m.brightness), true);
            this.addBgColorRule('.std-hover-bg' + m.pf + '.disabled:hover', OEColorHelper.stdBackgroundColor(m.brightness), true);
            this.addBgColorRule('.std-hover-bg-hover' + m.pf + ':hover', OEColorHelper.stdHoverBackgroundColor(m.brightness), true);

            this.addBgColorRule('.main-menu-bg' + m.pf, OEColorHelper.mainMenuBackgroundColor(m.brightness));
            this.addBgColorRule('.std-toolbar-bg' + m.pf, OEColorHelper.stdToolbarBackgroundColor(m.brightness));
            this.addBgColorRule('.view-bg' + m.pf, OEColorHelper.viewBackgroundColor(m.brightness));
            this.addBgColorRule('.start-view-bg' + m.pf, OEColorHelper.startViewBackgroundColor(m.brightness));

            this.addBgColorRule('.std-label-text-color-bg' + m.pf, OEColorHelper.stdLabelTextColor(m.brightness));
            this.addBgColorRule('.view-port-label-text-color-bg' + m.pf, OEColorHelper.viewPortLabelTextColor(m.brightness));

            this.addColorRule('.std-label-text-color' + m.pf, OEColorHelper.stdLabelTextColor(m.brightness));
            this.addColorRule('.view-port-label-text-color' + m.pf, OEColorHelper.viewPortLabelTextColor(m.brightness));
            this.addColorRule('.main-menu-text-color' + m.pf, OEColorHelper.mainMenuTextColor(m.brightness));

            this.addBgColorRule('.std-separator-color' + m.pf, OEColorHelper.stdSeparatorColor(m.brightness));
            this.addBgColorRule('.std-overlay-view-bg' + m.pf, OEColorHelper.stdOverlayViewBackgroundColor(m.brightness));

            this.addBorderColorRule('.std-label-border-color' + m.pf, OEColorHelper.stdLabelTextColor(m.brightness));
            this.addBorderColorRule('.std-border-color' + m.pf, OEColorHelper.stdSeparatorColor(m.brightness));
            this.addBorderColorRule('.std-separator-border-color' + m.pf, OEColorHelper.stdSeparatorColor(m.brightness));
            this.addBorderColorRule('.dark-border-color' + m.pf, OEColorHelper.darkSeparatorColor(m.brightness));
            this.addBorderColorRule('.dark-separator-border-color' + m.pf, OEColorHelper.darkSeparatorColor(m.brightness));

            this.addBorderRule('.std-border' + m.pf, OEColorHelper.stdSeparatorColor(m.brightness));
            this.addBorderRule('.dark-border' + m.pf, OEColorHelper.darkSeparatorColor(m.brightness));
            this.addBorderRule('.view-port-border' + m.pf, OEColorHelper.viewPortLabelTextColor(m.brightness));

            let color = OEColorHelper.viewPortLabelTextColor(m.brightness); color.w = 0.5;
            this.addBorderRule('.media-center-slide-preview-magni-border' + m.pf, color);
        }
    }

    updateColorStyle(brightness, borderBrightness, force = false)  {
        brightness = typeof(brightness) === 'number' ? brightness : this.brightness;
        borderBrightness = typeof(borderBrightness) === 'number' ? borderBrightness : this.borderBrightness;

        if(this.brightness === brightness && this.borderBrightness === borderBrightness && !force)  return;
        this.brightness = brightness;
        this.borderBrightness = borderBrightness;

        this.removeColorStyle();
        this.addColorStyle(brightness, borderBrightness);
    }

    updateFontStyle(fontFamily)  {
        this.removeRule('font-body');
        this.removeRule('font-default');
        this.removeRule('font-textarea');
        this.removeRule('font-input');
        this.removeRule('font-popover');
        this.removeRule('font-flow-nav-help');

        let fontFamily_ = fontFamily || 'Roboto, sans-serif';
        let rule = ' font-family: ' + fontFamily_ + ' ; ';

        this.insertRule('font-body', 'body { ' + rule + ' }');
        this.insertRule('font-default', '.default-font { ' + rule + ' }');
        this.insertRule('font-textarea', 'textarea { ' + rule + ' }');
        this.insertRule('font-input', 'input { ' + rule + ' }');
        this.insertRule('font-popover', '.popover { ' + rule + ' }');
        this.insertRule('font-flow-nav-help', '.flow-nav-view.help .flow-nav-menu-element.usage-rights .left .icon div { ' + rule + ' }');
    }

    addStyleSheetFiles(files)   {
        if(!files)  return;
        if(!Array.isArray(files))   files = [files];

        files = files.filter(file => this.additionalStyles.findIndex(style => style.file === file) < 0);
        if(!files.length)   return;

        files.forEach(file => {
            let link = this.document.createElement('link');
            link.type = 'text/css';
            link.rel = 'stylesheet';
            link.href = file;
            this.document.head.appendChild(link);
    
            this.additionalStyles.push({file: file, link: link});
        });
    }

    removeStyleSheetFiles(files)    {
        if(!files)  return;
        if(!Array.isArray(files))   files = [files];
        if(!files.length)   return;

        this.additionalStyles = this.additionalStyles.filter(style => {
            let included = files.includes(style.file);
            if(included)   this.document.head.removeChild(style.link);
            return !included;
        });
    }

    removeAllStyleSheetFiles()    {
        this.removeStyleSheetFiles(this.addStyleSheetFiles);
    }

    updateStyleMobile() {
        bowserTool.update();
        if(bowserTool.mobile)   {
            this.addStyleSheetFiles('app/public/styles/style_mobile.css');
        } else {
            this.removeStyleSheetFiles('app/public/styles/style_mobile.css');
        }
    }

    loadAdditionalStyles(config)  {
        let files = [];

        if(bowserTool.mobile)   files.push('app/public/styles/style_mobile.css');

        if([OEVersion.amboss, OEVersion.anatomy, OEVersion.ear, OEVersion.ionto, OEVersion.ortho, OEVersion.science, OEVersion.skin, OEVersion.sport, OEVersion.thieme].includes(config.version))  {
            files.push('app/public/styles/ext/style_ext_anatomy.css');
        } else if(config.version === OEVersion.bayer || config.version === OEVersion.eyeOCT || config.version === OEVersion.knowOn)  {
            files.push('app/public/styles/ext/style_ext_bayer.css');
        } else if(config.version === OEVersion.bbraun)  {
            files.push('app/public/styles/ext/style_ext_bbraun.css');
        } else if(config.version === OEVersion.cambridgeCell || config.version === OEVersion.cell)  {
            files.push('app/public/styles/ext/style_ext_anatomy.css');
            files.push('app/public/styles/ext/style_ext_cambridge.css');       // we need this styles for the cell version due to the animation media item preview image layout
        } else if(config.version === OEVersion.demo)  {
            files.push('app/public/styles/ext/style_ext_demo.css');
        } else if(config.version === OEVersion.equineHoof)  {
            files.push('app/public/styles/ext/style_ext_equine_hoof.css');
        } else if(config.version === OEVersion.implantcast)  {
            files.push('app/public/styles/ext/style_ext_implantcast.css');
        } else if(config.version === OEVersion.school)  {
            files.push('app/public/styles/ext/style_ext_anatomy.css');
            files.push('app/public/styles/ext/style_ext_school.css');
        } else if(config.version === OEVersion.surgery)  {
            files.push('app/public/styles/ext/style_ext_surgery.css');
        } else if(config.version === OEVersion.toxnetz)  {
            files.push('app/public/styles/ext/style_ext_toxnetz.css');
        } else if(config.version === OEVersion.xRay || config.version === OEVersion.xRayMin)  {
            files.push('app/public/styles/ext/style_ext_xray.css');
        } else if(config.target === OETarget.xRayIcarus || config.version === OEVersion.xRayIcarus)  {
            files.push('app/public/styles/ext/style_ext_xray_icarus.css');
        } else if(config.version === OEVersion.zeissOpti)  {
            files.push('app/public/styles/ext/style_ext_zeiss_opti.css');
        }

        this.additionalStyles = this.additionalStyles.filter(style => {
            let included = files.includes(style.file);
            if(!included)   this.document.head.removeChild(style.link);
            return included;
        });

        this.addStyleSheetFiles(files);
    }

    updateForConfig(config)   {
        this.updateFontStyle(config.font.family);
        this.loadAdditionalStyles(config);
    }
}

export default new OEStyleSheetTool(document, true);